import React, { useState } from "react";
import Button from '@mui/material/Button';
import Title from './Title';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import PublicGoogleSheetsParser from "./google-parser";
import { CSVLink } from "react-csv";
import { serverUrlOverwrites } from "./server-url-overwrites";
import ProgressiveRow from "./ProgressiveRow";
import Checkbox from '@mui/material/Checkbox';
import Progressive from "./Progressive";

import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import ListItemText from '@mui/material/ListItemText';
import Select from '@mui/material/Select';
import { publicationMap, trustedPublications } from "./trusted-publications";
import Grid from '@mui/material/Grid';

import Box, { BoxProps } from '@mui/material/Box';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250,
        },
    },
};

const spreadsheetId = '1xaAHLKZ8VqgsK30xI-TmH3nopmnb4Xp2wq6sbCFBYOY'

let data = [];

const headers = [
    { label: "Account address", key: "mastodon" },
    { label: "Show boosts", key: "boosts" }
];

export default function Parser(props) {
    const [progressives, setProgressives] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    const [filteredPublications, setFilteredPublications] = React.useState([]);
    const [publications, setPublications] = React.useState([]);

    const handleChange = (event) => {
        const {
            target: { value },
        } = event;
        setFilteredPublications(
            typeof value === 'string' ? value.split(',') : value,
        );
    };

    function extractPublications(progressive, text) {
        let publication = text.trim();
        let tempPublication = publication.toLowerCase();
        Object.keys(publicationMap).forEach((key) => {
            let searchTerm = key.toLowerCase();
            if (tempPublication.includes(searchTerm)) {
                if (!progressive.knownPublications.includes(publicationMap[key])) {
                    progressive.knownPublications.push(publicationMap[key]);
                }
                let index = tempPublication.indexOf(searchTerm);
                tempPublication = tempPublication.substring(0, index) + tempPublication.substring(index + key.length);
                // publication = publication.substring(0, index) + publication.substring(index + key.length);
            }
        });
    }

    function deduped(progressives) {
        let dedupedNames = [];
        return progressives.filter((progressive) => {
            let mastodon = progressive.mastodon.toLowerCase();
            if (!dedupedNames.includes(mastodon)) {
                dedupedNames.push(mastodon);
                return true;
            }
            return false;
        });
    }

    function getItems() {
        setIsLoading(true);
        const parser = new PublicGoogleSheetsParser();

        const propertyMap = {
            'What are your main areas of focus for your work?  ': 'focus',
            'What is your Mastodon handle (@user@instance.name)? Sheet maintained by @tchambers@indieweb.social ': 'mastodon',
            'What name do you wish to be listed by? ': 'name',
            'Other info for short self-description  ': 'title',
            'Which organization or company do you work for? ': 'publication',
            'Do you have a Twitter handle you would like to share? (This can help people you know on Twitter to find you on Mastodon)  ': 'twitter',
        };

        let publicationNames = [];

        parser.parse(spreadsheetId).then(items => {
            let i = 1;
            console.log(items);
            data = deduped(items.map((item) => {
                let progressive = new Progressive(i);
                for (let key in item) {
                    if (item.hasOwnProperty(key)) {
                        let property = propertyMap[key];
                        if (property) {
                            if (property === 'mastodon') {
                                let mastodonUrl = item[key].replace(/\s/g, '').trim();
                                if (mastodonUrl.indexOf('http') > -1 || mastodonUrl.includes('/')) {
                                    if (!mastodonUrl.includes('http')) {
                                        mastodonUrl = 'https://' + mastodonUrl;
                                    }
                                    let urlInfo = (new URL(mastodonUrl));
                                    let domain = urlInfo.hostname;
                                    let username = urlInfo.pathname.substring(urlInfo.pathname.lastIndexOf('/') + 1);
                                    mastodonUrl = username + '@' + domain;
                                }

                                progressive.mastodon = mastodonUrl.charAt(0) === '@' ? mastodonUrl.substring(1) : mastodonUrl;

                                const mastodonUrlParts = progressive.mastodon.split('@');

                                progressive.mastodonUrl = 'https://' + (serverUrlOverwrites[mastodonUrlParts[1]] ? serverUrlOverwrites[mastodonUrlParts[1]] : mastodonUrlParts[1]) + '/@' + mastodonUrlParts[0];
                            } else if (property === 'publication') {
                                extractPublications(progressive, item[key]);
                                // publication =  publication.trim();
/*                                if (publication.length > 0) {
                                    matchedPublications.push(publication);
                                }*/
                                progressive.publication = item[key];
                                /*progressive.publication = (
                                    <div>
                                        {progressive.knownPublications.map(publication => ( <strong key={publication}>{publication}, </strong>))} <span>{publication}</span>
                                        </div>);*/
                            } else if (property === 'twitter') {
                                progressive.twitter = formatTwitter(item[key].trim());
                            } else if (property === 'title') {
                                extractPublications(progressive, item[key]);
                                progressive.title = item[key].trim();
                            } else {
                                progressive[property] = item[key].trim();
                            }
                        }
                    }
                }
                publicationNames = publicationNames.concat(progressive.knownPublications).sort((a, b) => trustedPublications[a].name.localeCompare(trustedPublications[b].name));
                setPublications([...new Set(publicationNames)]);
                i++;
                return progressive;
            }).filter((item) => {
                return item.mastodon.includes('@');
            }));
            setProgressives(data);
            setIsLoading(false);
            // items should be [{"a":1,"b":2,"c":3},{"a":4,"b":5,"c":6},{"a":7,"b":8,"c":9}]
        });
    }

    function toggleCheckbox(row, property, e) {
        setProgressives(
            progressives.map(item =>
                item.id === row.id
                    ? {...row, [property] : e.target.checked}
                    : item
            ));
    }

    function formatTwitter(twitter) {
        let handle = twitter.charAt(0) === '@' ? twitter.substring(1) : twitter;
        // can't use handles with spaces - probably description
        if (handle.includes(' ')) {
            return handle;
        }
        if (handle.indexOf('http') > -1) {
            return (<a href={handle} target="_blank" rel="noopener noreferrer">{handle}</a>);
        }

        return (<a href={'https://twitter.com/' + handle} target="_blank" rel="noopener noreferrer">{handle}</a>);
    }

    function toggleCheckbox(row, property, e) {
        setProgressives(
            progressives.map(item =>
                item.id === row.id
                    ? {...row, [property] : e.target.checked}
                    : item
            ));
    }

    function toggleAll(e) {
        setProgressives(
            progressives.map(item => {
                return {...item, include: e.target.checked}
            }));
    }

    function filterProgressives(row) {
        if (!filteredPublications.length) {
            return true;
        }

        return row.knownPublications.some(r => filteredPublications.includes(r));
    }

    return (
        <div>
            <p>You can use this tool to load the public list of US Progressives who've set up their presence on Mastodon, and export them to a CSV file.</p>
            <p>You can use that file to follow selected progressives by going to your Mastodon server in a browser, clicking Preferences > Import and export -> Import. There you can select the file exported from this site in the "Data" section. Make sure you've selected "Merge" and that Import type is set to "Following list".</p>
            <p>This tool uses the <a href="https://docs.google.com/spreadsheets/d/1xaAHLKZ8VqgsK30xI-TmH3nopmnb4Xp2wq6sbCFBYOY/edit" target="_blank" rel="noopener noreferrer">Google Docs Sheet</a> Maintained by <a href="https://indieweb.social/web/@tchambers" target="_blank" rel="noopener noreferrer">@tchambers@indieweb.social</a></p>
            <p><strong>Are you a US Progressive and want to add your info? Then go here: <a href="https://forms.gle/HJbjikV9KVGptMxN9" target="_blank" rel="noopener noreferrer">https://forms.gle/HJbjikV9KVGptMxN9</a></strong></p>
            <p>Created by <a href="https://meowr.me/web/@boskee" target="_blank" rel="noopener noreferrer">@boskee@meowr.me</a>. Found any errors or inaccuracies? Let me know on Mastodon.</p>
            { progressives.length > 0 ? <><CSVLink data={progressives.filter(task => task.include)} headers={headers} className="download-csv" filename={"mastodon-progressives.csv"} enclosingCharacter={``}>
                Download CSV Export
            </CSVLink>
                <Grid container spacing={2}>
                    <Grid item xs={6} md={8}>
{/*                        <FormControl sx={{ m: 1, width: 300 }}>
                            <InputLabel id="demo-multiple-checkbox-label">Publication</InputLabel>
                            <Select
                                labelId="demo-multiple-checkbox-label"
                                id="demo-multiple-checkbox"
                                multiple
                                value={filteredPublications}
                                onChange={handleChange}
                                input={<OutlinedInput label="Publication" />}
                                renderValue={(selected) => selected.map(v => trustedPublications[v].name).join(', ')}
                                MenuProps={MenuProps}
                            >
                                {publications.map((name) => (
                                    <MenuItem key={name} value={name}>
                                        <Checkbox checked={filteredPublications.indexOf(name) > -1} />
                                        <ListItemText primary={trustedPublications[name].name} />
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>*/}
                    </Grid>
                    <Grid item xs={6} md={4}>
                        <FormGroup sx={{ m: 1, flexDirection: 'row-reverse' }}>
                            <FormControlLabel control={<Checkbox  onChange={e => {
                                e.persist();
                                toggleAll(e);
                            }}/>} label="Toggle All" />
                        </FormGroup>
                    </Grid>
                </Grid>
            </> : null }
            <Table size="small">
                <TableHead>
                    <TableRow>
                        <TableCell>Name</TableCell>
                        <TableCell>Mastodon</TableCell>
                        <TableCell>Twitter</TableCell>
                        {/*<TableCell width="20%">Detected Publication(s)</TableCell>*/}
                        <TableCell>Focus, Self-Description, Organisations</TableCell>
{/*                        <TableCell>Show Boosts?</TableCell>*/}
                        <TableCell>Export?</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {progressives.filter(row => filterProgressives(row)).map((row) => (<ProgressiveRow progressive={row} key={row.id} checkboxHandler={toggleCheckbox}/> ))}
                </TableBody>
            </Table>
            <Button
                type="button"
                fullWidth
                variant="contained"
                sx={{ mt: 3, mb: 2 }}
                onClick={getItems}
                disabled={isLoading || progressives.length > 0}
            >
                Load Progressives
            </Button>
        </div>
    )
}
